export const NumberFormatter = ({ number }) => {
    // Convert the number to a formatted string
    const formattedNumber = Number(number).toLocaleString('en-IN', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    });

    return formattedNumber;
};